export const initCriterion = {
  id: null,
  internal_id: null,
  name: '',
  description: '',
  conditions: [],
  delivery_method_ids: [],
}
